import React, { Component } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { currentTabSelector, disabledTabsSelector } from '../../selectors/admin/tabs';
import { setTab } from '../../actions/admin/tabs';
import { ARE_YOU_SURE_TEXT } from '../../constants/texts/errors';

class CKPTabs extends Component {
    _changeTab = tab => {
        this.props.setTab(tab);
        this.props.onTabSwitch && this.props.onTabSwitch(tab);
    };
    _switchTab = (_e, tab) => {
        if (this.props.disabled) {
            if (window.confirm(ARE_YOU_SURE_TEXT)) {
                this._changeTab(tab);
            }
        } else {
            this._changeTab(tab);
        }
    };
    _getCurrentTab = () => {
        if (this.props.currentTab > this.props.labels.length - 1) {
            return 0;
        }
        return this.props.currentTab;
    };
    render() {
        if (this.props.disable) {
            return this.props.content[this._getCurrentTab()];
        } else {
            return (
                <div className={`ckp-tabs ${this.props.inline ? 'is-inline' : ''}`}>
                    <div className="ckp-tabs-select">
                        <Tabs
                            classes={{ indicator: 'ckp-tabs-indicator' }}
                            value={this._getCurrentTab()}
                            onChange={this._switchTab}
                        >
                            {this.props.labels.map(l => (
                                <Tab
                                    key={l}
                                    classes={{ label: 'ckp-tabs-label' }}
                                    className="ckp-tabs-option"
                                    label={l}
                                />
                            ))}
                        </Tabs>
                    </div>
                    <div className="ckp-tabs-content">{this.props.content[this._getCurrentTab()] || null}</div>
                </div>
            );
        }
    }
}

const mapStateToProps = state => ({
    currentTab: currentTabSelector(state),
    disabled: disabledTabsSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ setTab }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CKPTabs);



// WEBPACK FOOTER //
// ./src/containers/admin/AdminTabs.js